// ABOUTME: Draggable resize handle component for resizable panels.
// ABOUTME: Supports mouse and touch events with visual feedback on hover/drag.

import { memo } from "react"

interface CResizeHandleProps {
  position: "left" | "right"
  isResizing: boolean
  onMouseDown: (e: React.MouseEvent) => void
  onTouchStart: (e: React.TouchEvent) => void
  onDoubleClick?: () => void
}

export const CResizeHandle = memo(
  ({ position, isResizing, onMouseDown, onTouchStart, onDoubleClick }: CResizeHandleProps) => {
    const positionClasses = position === "left" ? "left-0 -translate-x-[85%]" : "right-0 translate-x-[85%]"

    return (
      <div
        className={`absolute top-0 ${positionClasses} w-4 h-full cursor-col-resize z-50
        transition-colors bg-transparent hover:bg-black/5 touch-none
        ${isResizing ? "bg-black/5" : ""}`}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        onDoubleClick={onDoubleClick}
        // A pointer-only affordance: it is dragged, never operated from the keyboard,
        // so it has nothing to offer assistive technology and stays out of its tree.
        aria-hidden="true"
      />
    )
  },
)
